<div class="row m-0 justify-content-center" style="padding-top: 25px" *ngIf="isCheckIn && dato">
  <div class="col-12 p-0 m-0 container-items">
    <div class="d-flex container-item-card justify-content-between" style="border: 1px solid #c2c2c3; border-radius: 8px; gap: 25px">
      <!-- Imagen -->
      <div class="w-100" style="max-width: 175px">
        <img
          style="width: 100%; height: 100%; object-fit: cover; border-top-left-radius: 6px; border-bottom-left-radius: 6px"
          [src]="getImageCover()"
          alt=""
        />
      </div>

      <div class="px-0" style="width: calc(100% - 190px)">
        <!-- Título, categoría, estado y acciones -->
        <div class="d-flex justify-content-between align-items-start">
          <div class="d-flex align-items-center pt-2" style="gap: 12px">
            <p class="mb-0 boat-title">{{ dato.title }}</p>
            <span
              *ngIf="category"
              class="px-3 d-flex align-items-center text-capitalize boat-category"
            >
              {{ category }}
            </span>
          </div>

          <div class="d-flex">
            <div class="pt-2 pr-3 d-flex align-items-center" style="gap: 5px">
              <span
                class="status-circle"
                style="background-color: #000000; color: #ffffff"
                [tooltip]="dato.status"
                placement="bottom"
              >{{ dato.status?.charAt(0) }}</span>
              <span
                class="status-circle"
                [style.background-color]="isRefundable ? '#7ae0a8' : '#fde6ea'"
                [style.color]="isRefundable ? '#0c5d33' : '#ed3b5b'"
                [tooltip]="isRefundable ? 'Reembolsable' : 'No reembolsable'"
                placement="bottom"
              >{{ isRefundable ? 'R' : 'NR' }}</span>
            </div>

            <div
              *ngIf="dato.status_id === 1 || dato.status_id === 2"
              class="d-flex align-items-end justify-content-center"
              style="border-bottom: 1px solid #ccc; border-left: 1px solid #ccc; border-bottom-left-radius: 6px; padding: 10px 15px"
            >
              <div *ngIf="dato.status_id === 1" style="width: 25px; height: 25px">
                <img
                  style="margin-top: -4px; cursor: pointer"
                  tooltip="Eliminar producto"
                  (click)="removeItem(dato)"
                  placement="bottom"
                  src="../../../../assets/icons/summary/delete.svg"
                  alt=""
                />
              </div>
              <div *ngIf="dato.status_id === 2" style="width: 25px; height: 25px">
                <img
                  style="
                    margin-top: -4px;
                    cursor: pointer;
                    filter: invert(16%) sepia(99%) saturate(7493%) hue-rotate(1deg) brightness(95%) contrast(119%);
                  "
                  tooltip="Cancelar producto"
                  (click)="removeItem(dato)"
                  placement="bottom"
                  src="../../../../assets/icons/itinerary-detail/04-01.svg"
                  alt=""
                />
              </div>
            </div>
          </div>
        </div>

        <div class="d-flex justify-content-between align-items-stretch" style="margin-top: 15px; margin-bottom: 15px">
          <!-- Puerto y check-in -->
          <div class="d-flex flex-column justify-content-center" style="width: 34%; min-height: 62px">
            <div class="d-flex align-items-start" style="gap: 4px">
              <img width="20px" height="22px" src="../../../../assets/icons/itinerary/lugar.svg" alt="" />
              <p class="mb-0 boat-text boat-text--strong">{{ location }}</p>
            </div>
            <span *ngIf="dato.checkInTime" class="boat-checkin">Check-In: {{ dato.checkInTime }} hs</span>
          </div>

          <div style="width: 1px; background-color: #ccc"></div>

          <!-- Cabinas y capacidad -->
          <div class="d-flex flex-column justify-content-center pl-3" style="width: 32%; gap: 8px">
            <div>
              <p class="mb-0 boat-text">Cabinas:</p>
              <p class="mb-0 boat-text boat-text--strong">
                {{ boat?.cabinCount || 0 }} Cabinas<ng-container *ngIf="skipperIncluded"> (+1p/ Capitán)</ng-container>
              </p>
            </div>
            <div>
              <p class="mb-0 boat-text">Capacidad:</p>
              <p class="mb-0 boat-text boat-text--strong">{{ boat?.peopleMax || 0 }} Pasajeros</p>
            </div>
          </div>

          <div style="width: 1px; background-color: #ccc"></div>

          <!-- Precio -->
          <div class="d-flex flex-column pr-3" style="width: 28%; align-items: flex-end; justify-content: center">
            <p class="mb-0 boat-price-currency">{{ currencyAgency?.code }}</p>
            <div class="d-flex align-items-center">
              <p class="mb-0 boat-price">{{ getPrice() | number: "1.2-2" }}</p>
              <usb-tooltip-convert-amount
                *ngIf="dato.status_id !== 5"
                [clientsSettingAppBooking]="clientSetting"
                [currencyProduct]="currencyAgency?.code"
                [valueProduct]="getPrice()"
              ></usb-tooltip-convert-amount>
            </div>
            <ng-container *ngIf="dato.status_id !== 5 && dato.currency !== currencyAgency?.code">
              <p class="mb-0 boat-text boat-text--muted">Imp. Incl.</p>
              <p class="mb-0 boat-text boat-text--strong">
                <span style="color: #616161">{{ dato.currency }}</span>
                {{ dato.netPriceBooking > 0 ? dato.netPriceBooking : dato.totalPrice | number: "1.2-2" }}
              </p>
            </ng-container>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
